var _rect, _circle, _path, _path2, _path3, _path4, _circle2, _circle3, _path5, _circle4, _circle5, _ellipse, _path6, _path7, _path8, _ellipse2, _ellipse3, _path9, _ellipse4, _circle6, _ellipse5, _circle7, _path10, _path11, _path12, _path13, _path14, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#243a63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 52,
    fill: "#3e5175",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 124C12 98 34 90 60 90S108 98 108 124Z",
    fill: "#3a4a66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88L58 104L52 94Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87L60 100L74 87L68 85L60 92L52 85Z",
    fill: "#fbfaf5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100L60 124",
    stroke: "#2e3b51",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 108,
    r: 1.3,
    fill: "#2e3b51"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 116,
    r: 1.3,
    fill: "#2e3b51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52 70H68V92C66 96 54 96 52 92Z",
    fill: "#d8b99d"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 56,
    r: 5,
    fill: "#f6d3b3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 52,
    rx: 21,
    ry: 25,
    fill: "#f6d3b3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 84C50 94 70 94 78 84L80 94C70 102 50 102 40 94Z",
    fill: "#d9453a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96L74 116L84 112L78 94Z",
    fill: "#ad372e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90L52 92M50 94L58 96",
    stroke: "#ad372e",
    strokeWidth: 1.6,
    opacity: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75,
    cy: 63,
    rx: 4,
    ry: 2.4,
    fill: "#e8806a",
    opacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 57Q56.5 62 59 63.5Q60 64 61.5 63.5",
    stroke: "#bfa48b",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69,
    cy: 54,
    rx: 2.5,
    ry: 3,
    fill: "#2a1d1a"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.9,
    cy: 53,
    r: 0.9,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47L56 47",
    stroke: "#c0a040",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 47L74 47",
    stroke: "#c0a040",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69Q60 72 68 66",
    stroke: "#2a1d1a",
    strokeWidth: 2.2,
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50L33 33L43 38L45 21L54 31L60 17L66 31L75 21L77 38L87 33L83 50C77 41 69 36 60 36C51 36 43 41 37 50Z",
    fill: "#f2d36a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M39 44L82 50",
    stroke: "#1d1d28",
    strokeWidth: 2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51,
    cy: 54,
    rx: 7.5,
    ry: 6.5,
    fill: "#1d1d28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait16);
export default __webpack_public_path__ + "static/media/player-portrait-16.74c5b49085c2b16d87e2f588aadfcc3a.svg";
export { ForwardRef as ReactComponent };